import { useRef } from "react";
import Draggable from "react-draggable";
import { Popover, PopoverOrigin } from "@mui/material";
import { useTranslate } from "@/hooks";
import { colorPrimary } from "@/constants/colors";
import CustomButton from "../CustomButton/CustomButton";
import { IDraggablePopoverComponentProps } from "./DraggablePopoverComponent.props";
import styles from "./DraggablePopoverComponent.module.scss";

const defaultOffset: PopoverOrigin = {
	vertical: "top",
	horizontal: "left",
};

const DraggablePopoverComponent = ({
	children,
	header,
	anchorEl,
	setAnchorEl,
	anchorOrigin = defaultOffset,
	transformOrigin = defaultOffset,
	additionalButtons,
	disableDefaultCloseButton = false,
	closeHandler,
	sx,
	customFilling,
}: IDraggablePopoverComponentProps): JSX.Element => {
	const popoverNodeRef = useRef<HTMLDivElement>(null); // ссылка на popover

	const translate = useTranslate(); // hook для перевода текста

	const onClose = (): void => {
		closeHandler && closeHandler();
		setAnchorEl(null);
	};

	return (
		<Draggable nodeRef={popoverNodeRef} handle="h3" onMouseDown={(e) => e.stopPropagation()}>
			<Popover
				anchorEl={anchorEl}
				open={Boolean(anchorEl)}
				onClose={onClose}
				ref={popoverNodeRef}
				anchorOrigin={anchorOrigin}
				transformOrigin={transformOrigin}
				sx={{
					"& .MuiPopover-paper.MuiPaper-root": {
						padding: "16px",
						color: colorPrimary,
						textAlign: "left",
						display: "flex",
						flexDirection: "column",
						gap: "12px",
						...sx,
					},
				}}
			>
				{customFilling ? (
					children
				) : (
					<>
						{header && <h3 className={styles.areaToCaptureMovement}>{translate(header)}</h3>}

						<div className={styles.mainContent}>{children}</div>

						{!disableDefaultCloseButton && (
							<div className={styles.buttonBlock}>
								{/* доп.кнопки */}
								{additionalButtons}
								{/* закрыть */}
								<CustomButton fullWidth onClick={onClose}>
									{translate("button_close")}
								</CustomButton>
							</div>
						)}
					</>
				)}
			</Popover>
		</Draggable>
	);
};

export default DraggablePopoverComponent;
